var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 1001,
    viewBox: "0 0 1001 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500.5,
    cy: 500.5,
    r: 483.5,
    fill: "url(#paint0_linear_429_8137)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.824 816H229.503C203.601 816 186.671 799.794 186.237 774.036C185.948 755.658 185.803 737.426 186.527 719.05C187.395 697.344 197.958 680.704 216.769 670.429C278.557 636.714 340.635 603.721 402.426 570.15C406.912 567.69 409.661 570.005 412.989 571.741C465.806 599.38 519.635 601.696 574.62 578.687C576.212 578.108 577.948 577.674 579.251 576.517C590.682 566.822 600.956 570.729 612.822 577.24C668.244 607.772 724.098 637.727 779.957 667.535C804.123 680.414 815.987 699.804 815.553 727.152C815.264 742.635 815.553 757.974 815.553 773.457C815.409 799.069 798.333 816 772.865 816H500.83L500.824 816Z",
    fill: "#0D0E15",
    fillOpacity: 0.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496.339 557.129C445.404 555.392 403.15 530.214 372.039 485.5C321.104 412.136 327.182 307.953 385.497 241.102C448.877 168.606 553.928 169.04 616.731 241.97C683.44 319.531 679.243 441.955 607.036 512.273C577.517 541.069 542.209 556.552 496.338 557.131L496.339 557.129Z",
    fill: "#0D0E15",
    fillOpacity: 0.73
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_429_8137",
    x1: 232.602,
    y1: 327.818,
    x2: 993.684,
    y2: 330.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#3A32AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D34C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.c7acf8ac75cb3f9561444ffafaba9608.svg";
export { ForwardRef as ReactComponent };